let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("gwFU3")]).then(() => parcelRequire('8gU8P'));